'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isProd = _enviro2.default.getShort() === 'prod';
var GOOGLE_ID = '984961564';

var TrackingPixel = {
  fire: function fire(link) {
    var img = void 0;
    if (isProd) {
      img = new Image();
      img.src = link;
      return link;
    }
  },
  googleAdwords: function googleAdwords(label) {
    var googleId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GOOGLE_ID;

    return TrackingPixel.fire('https://www.googleadservices.com/pagead/conversion/' + googleId + '/?label=' + label + '&guid=ON&script=0');
  },
  twitterAds: function twitterAds(txnId) {
    var pId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Twitter';
    var saleAmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var orderQty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    return TrackingPixel.fire('https://analytics.twitter.com/i/adsct?txn_id=' + txnId + '&p_id=' + pId + '&tw_sale_amount=' + saleAmount + '&tw_order_quantity=' + orderQty);
  },
  facebookCategory: function facebookCategory(id) {
    var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Lead';

    return TrackingPixel.fire('https://www.facebook.com/tr?id=' + id + '&ev=' + category + '&noscript=1');
  },
  quora: function quora(id) {
    return TrackingPixel.fire('https://www.quora.com/_/ad/' + id + '/pixel/');
  },
  bing: function bing(id) {
    return TrackingPixel.fire('https://bat.bing.com/action/0?ti=' + id + '&Ver=2');
  },
  clickMeter: function clickMeter(id) {
    return TrackingPixel.fire('https://www.clickmeter.com/conversion.aspx?id=' + id + '&val=0.00&param=empty&com=0.00&comperc=0.00&pixel=true');
  }
};

exports.default = TrackingPixel;
module.exports = exports['default'];